import { useMutateOnRefresh } from '@va/dashboard/util-hooks';
import { useNumberOfVisitsByMonth } from './apiClient';
import TrafficChartCard from './TrafficChartCard';

const VisitsByMonthChart = () => {
  const { data, isLoading, mutate } = useNumberOfVisitsByMonth();
  const { isManualRefreshing } = useMutateOnRefresh(mutate);
  return (
    <TrafficChartCard data={data} isLoading={isLoading || isManualRefreshing} baseKey={'trafficPageLoadsByMonth'} />
  );
};

export default VisitsByMonthChart;
